{
  "name": "orval",
  "description": "A swagger client generator for typescript",
  "version": "7.10.0",
  "license": "MIT",
  "files": [
    "dist"
  ],
  "bin": "dist/bin/orval.js",
  "type": "commonjs",
  "main": "dist/index.js",
  "keywords": [
    "rest",
    "client",
    "swagger",
    "open-api",
    "fetch",
    "data fetching",
    "code-generation",
    "angular",
    "react",
    "react-query",
    "svelte",
    "svelte-query",
    "vue",
    "vue-query",
    "msw",
    "mock",
    "axios",
    "vue-query",
    "vue",
    "swr",
    "zod",
    "hono"
  ],
  "author": {
    "name": "Victor Bury",
    "email": "victor@anymaniax.com"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/orval-labs/orval.git"
  },
  "scripts": {
    "build": "tsup ./src/bin/orval.ts ./src/index.ts --target node12 --clean --sourcemap --dts",
    "dev": "tsup ./src/bin/orval.ts ./src/index.ts --target node12 --clean --sourcemap --watch ./src --onSuccess 'yarn generate-api'",
    "lint": "eslint src/**/*.ts",
    "generate-api": "node ./dist/bin/orval.js --config ../../samples/react-query/basic/orval.config.ts",
    "test": "tsc --noEmit && vitest --passWithNoTests"
  },
  "devDependencies": {
    "@types/inquirer": "^9.0.6",
    "@types/js-yaml": "^4.0.8",
    "@types/lodash.uniq": "^4.5.8",
    "typedoc-plugin-coverage": "^3.4.1"
  },
  "dependencies": {
    "@apidevtools/swagger-parser": "^10.1.1",
    "@orval/angular": "7.10.0",
    "@orval/axios": "7.10.0",
    "@orval/core": "7.10.0",
    "@orval/fetch": "7.10.0",
    "@orval/hono": "7.10.0",
    "@orval/mcp": "7.10.0",
    "@orval/mock": "7.10.0",
    "@orval/query": "7.10.0",
    "@orval/swr": "7.10.0",
    "@orval/zod": "7.10.0",
    "ajv": "^8.17.1",
    "cac": "^6.7.14",
    "chalk": "^4.1.2",
    "chokidar": "^4.0.3",
    "enquirer": "^2.4.1",
    "execa": "^5.1.1",
    "find-up": "5.0.0",
    "fs-extra": "^11.3.0",
    "lodash.uniq": "^4.5.0",
    "openapi3-ts": "4.2.2",
    "string-argv": "^0.3.2",
    "tsconfck": "^2.0.1",
    "typedoc": "^0.28.0",
    "typedoc-plugin-markdown": "^4.4.2",
    "typescript": "^5.6.3"
  }
}
